import { ProjectPurchaseItem } from "@/models/project-purchase-item.model"
import { type IProjectPurchaseItem } from "@/interfaces/api/project-purchase-item.interface"
import { ProjectPurchaseItemRepository } from "@/repositories/project-purchase-item.repository"
import { useProjectsPurchaseItemsStore } from "@/store/projects-purchase-items.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { storeToRefs } from "pinia"
import { AbstractProjectAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-project-administrative-item-controller"

export class ProjectPurchaseItemController extends AbstractProjectAdministrativeItemController<
  ProjectPurchaseItem,
  IProjectPurchaseItem,
  ProjectPurchaseItemRepository
> {
  constructor() {
    const projectsPurchaseItemsStore = useProjectsPurchaseItemsStore()
    const { projectsPurchaseItems } = storeToRefs(projectsPurchaseItemsStore)
    const storeFunctionsConfig = {
      collection: projectsPurchaseItems
    }

    super(ProjectPurchaseItem, storeFunctionsConfig, new ProjectPurchaseItemRepository())
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProjectPurchaseItem,
      projectsPurchaseItems
    )
  }
}
